import moment from 'moment'
export default {
  // 基础信息
  id: {
    label: 'ID',
    width: 40,
    style: {
      textAlign: 'center'
    }
  },
  loginName: {
    label: '账号',
    width: 80,
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input',
      rules: [{
        type: 'required',
        message: '请输入账号'
      }]
    }
  },
  jobNumber: {
    label: '工号',
    width: 80,
    style: {
      textAlign: 'center'
    },
    filter: {
      type: 'input'
    },
    form: {
      type: 'input'
      // rules: [{
      //   type: 'required',
      //   message: '请输入工号'
      // }]
    }
  },
  name: {
    label: '户名',
    width: 140,
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input',
      rules: [{
        type: 'required',
        message: '请输入户名'
      }]
    }
  },
  linkTel: {
    label: '联系电话',
    width: 120,
    minLength: 200,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 100,
      type: 'input'
    },
    form: {
      type: 'input'
    }
  },
  linkPhone: {
    label: '联系号码',
    style: {
      textAlign: 'center'
    },
    width: 100,
    minLength: 200,
    filter: {
      width: 100,
      type: 'input'
    },
    form: {
      type: 'input'
    }
  },
  orgId: {
    label: '班组',
    width: 120,
    type: 'select',
    relation: 'orgs',
    filter: {
      type: 'select',
      live: true
    },
    form: {
      type: 'select',
      live: true,
      rules: [{
        type: 'required',
        message: '请选择班组'
      }]
    }
  },
  orgParentId: {
    label: '客服分区',
    width: 120,
    type: 'select',
    relation: 'orgs',
    filter: {
      type: 'select',
      live: true
    },
    form: {
      type: 'select',
      live: true,
      rules: [{
        type: 'required',
        message: '请选择客服分区'
      }]
    }
  },
  enabled: {
    label: '启用状态',
    width: 120,
    sort: true,
    type: 'select',
    relation: 'enabled',
    style: {
      textAlign: 'center'
    },
    filter: {
      type: 'select',
      width: 100
    },
    form: {
      type: 'select'
    }
  },
  title: {
    label: '头衔',
    form: {
      type: 'input'
    }
  },
  email: {
    label: '电子邮箱',
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input'
    }
  },
  phone: {
    label: '电话',
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input'
    }
  },
  mobile: {
    label: '手机',
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input'
    }
  },
  address: {
    label: '地址',
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input',
      large: true
    }
  },
  remark: {
    label: '备注',
    filter: {
      type: 'input',
      like: true
    },
    form: {
      type: 'input',
      large: true,
      rules: [{
        type: 'maxLength',
        value: 120,
        message: '字数不能大于120个字'
      }]
    }
  },
  qq: {
    label: 'QQ',
    form: {
      type: 'input'
    }
  },
  nickname: {
    label: '昵称',
    form: {
      type: 'input'
    }
  },
  sex: {
    label: '性别',
    type: 'select',
    form: {
      type: 'select'
    }
  },
  updateTime: {
    label: '更新时间',
    type: 'time',
    filter: {
      type: 'daterange'
    }
  },
  // 具体抄表业务字段
  code: {
    label: '户号',
    width: 115,
    minLength: 200,
    filter: {
      type: 'input',
      like: true
    },
    style: {
      textAlign: 'center'
    },
    form: {
      type: 'input',
      rules: [{
        type: 'required',
        message: '户号'
      }]
    }
  },
  longitude: {
    label: '经度'
  },
  latitude: {
    label: '纬度'
  },
  amapLongitude: {
    label: '高德经度'
  },
  amapLatitude: {
    label: '高德纬度'
  },
  preWaterUsage: {
    label: '上期水量（吨）',
    width: 160,
    filter: {
      type: 'input',
      like: true
    }
  },
  bookId: {
    label: '区本号',
    // type: 'select',
    width: 90,
    filter: {
      type: 'input',
      like: true
    }
  },
  bookName: {
    label: '区本名称',
    width: 115
  },
  readingUserId: {
    label: '营销员',
    type: 'select',
    width: 120,
    minLength: 110,
    relation: 'readingUsers',
    filter: {
      type: 'select'
    }
  },
  readingUserName: {
    label: '抄表员',
    width: 100
  },
  readingStatusName: {
    label: '上期抄表状态',
    type: 'select',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  readingStatusId: {
    label: '本期抄表状态',
    width: 130,
    type: 'select',
    style: {
      textAlign: 'center'
    },
    relation: 'readingStatus',
    filter: {
      type: 'select'
    },
    form: {
      type: 'select'
    }
  },
  readingStatusPreId: {
    label: '上期抄表状态',
    type: 'select',
    style: {
      textAlign: 'center'
    },
    relation: 'readingStatus',
    width: 130
  },
  scheduleStatusName: {
    label: '状态',
    width: 92,
    style: {
      textAlign: 'center'
    },
    type: 'custom',
    isHtml: true,
    customRender (data, full, column, index) {
      return data + '　' + full.readingNum + '/' + full.totalNum
    }
  },
  workDate: {
    label: '抄表日期',
    width: 120,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD'
  },
  workDay: {
    label: '抄表（第几日）日期',
    width: 120,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD'
  },
  scheduleId: {
    label: '排期'
  },
  waterMeterId: {
    label: '水表'
  },
  waterUserId: {
    label: '用水户',
    type: 'select',
    width: 100,
    relation: 'waterUsers',
    filter: {
      type: 'select'
    }
  },
  waterUserName: {
    label: '户名',
    width: 120,
    filter: {
      type: 'input'
    }
  },
  waterUserAddress: {
    label: '地址',
    filter: {
      type: 'input'
    }
  },
  waterUserCode: {
    label: '户号',
    width: 120,
    minLength: 200
  },
  bookInternalNumber: {
    label: '册内序号',
    style: {
      textAlign: 'center'
    },
    width: 100
  },
  paymentCode: {
    label: '缴费号',
    width: 120,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 100,
      type: 'input'
    }
  },
  runNumPre: {
    label: '上期水表指度',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  runNumNow: {
    label: '本期水表指度',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  estimateNumPre: {
    label: '上期核量',
    style: {
      textAlign: 'center'
    }
  },
  estimateNumNow: {
    label: '本期核量',
    style: {
      textAlign: 'center'
    }
  },
  feeNumPre: {
    label: '上期算量指度',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  feeNumNow: {
    label: '本期算量指度',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  waterUsePre: {
    label: '上期用水量',
    style: {
      textAlign: 'center'
    },
    width: 120
  },
  waterUseNow: {
    label: '本期用水量',
    style: {
      textAlign: 'center'
    },
    width: 120
  },
  arrearagePrice: {
    label: '欠费金额',
    style: {
      textAlign: 'center'
    }
  },
  avgWaterUse: {
    label: '次平均用水量',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  dataSourceId: {
    label: '数据来源'
  },
  reading: {
    label: '是否已抄/已处理'
  },
  readingTime: {
    label: '抄表时间',
    width: 150,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD'
  },
  createUserId: {
    label: '创建人ID'
  },
  createTime: {
    label: '创建时间',
    type: 'time',
    style: {
      textAlign: 'center'
    },
    filter: {
      type: 'daterange'
    }
  },
  areaCode: {
    label: '区',
    width: 70,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 70,
      type: 'input'
    }
  },
  bookCode: {
    label: '本',
    width: 70,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 70,
      type: 'input'
    }
  },
  pageCode: {
    label: '页',
    width: 70,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 70,
      type: 'input'
    },
    type: 'custom',
    customRender: (data) => {
      if (data.length >= 7) {
        return data.substr(5)
      } else {
        return data
      }
    }
  },
  totalUserNum: {
    label: '户数',
    width: 80,
    style: {
      textAlign: 'center'
    },
    sort: true,
    filter: {
      type: 'input',
      like: true
    }
  },
  waterMeterLocation: {
    label: '水表位置'
  },
  barcode: {
    label: '水表自编号',
    style: {
      textAlign: 'center'
    },
    width: 120
  },
  caliberDigit: {
    label: '口径/位数',
    width: 105,
    type: 'custom',
    customRender: (data, full) => {
      return full.caliber + ' / ' + (full.meterDigit || 0)
    }
  },
  caliber: {
    label: '口径'
  },
  meterDigit: {
    label: '位数'
  },
  waterMeterOrigin: {
    label: '水表产地',
    width: 105
  },
  outerCode: {
    label: '水表表号',
    style: {
      textAlign: 'center'
    },
    width: 120
  },
  chargeStandard: {
    label: '计费方式',
    width: 100
  },
  readingCycle: {
    label: '抄表周期',
    width: 100,
    style: {
      textAlign: 'center'
    },
    type: 'custom',
    customRender: (data) => {
      // return data ? (data + '月') : '-'
      return data
    }
  },
  feeTypeId: {
    label: '水价标准',
    width: 100,
    relation: 'feeType',
    type: 'select'
  },
  rubTypeId: {
    label: '垃圾费核定标准',
    width: 140
  },
  uploadTime: {
    label: '实际完成日期',
    width: 130,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD'
  },
  readingNum: {
    label: '本期已抄户数',
    width: 130,
    style: {
      textAlign: 'center'
    },
    filter: {
      width: 70,
      type: 'input'
    }
  },
  leakReadingNum: {
    label: '本期漏抄户数',
    width: 130,
    style: {
      textAlign: 'center'
    },
    type: 'custom',
    customRender: (data, full) => {
      return (full.needReadingNum || 0) - (full.readingNum || 0)
    }
  },
  needReadingNumPre: {
    label: '上期应抄户数',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  needReadingNum: {
    label: '本期应抄户数',
    style: {
      textAlign: 'center'
    },
    width: 130
  },
  waterUserNumChangeRate: {
    label: '户数增减比率',
    style: {
      textAlign: 'center'
    },
    type: 'custom',
    customRender: (data) => {
      return data ? (data + '%') : 0
    },
    width: 130
  },
  abnormalWaterUserNum: {
    label: '水量异常户数',
    width: 130,
    style: {
      textAlign: 'center'
    },
    type: 'custom',
    customRender: (data, full) => {
      return full.needReadingNum - full.normalWaterUser
    }
  },
  normalWaterUser: {
    label: '正常率',
    type: 'custom',
    width: 100,
    style: {
      textAlign: 'center'
    },
    customRender (data, full, column, index) {
      const res = ((data || 0) / (full.needReadingNum || 0)) * 100
      return res ? (res + '%') : 0
    }
  },
  waterUseNumChangeRate: {
    width: 130,
    label: '水量增减比率',
    type: 'custom',
    customRender: (data) => {
      return data ? (data + '%') : 0
    },
    style: {
      textAlign: 'center'
    }
  },
  avgReadingTime: {
    label: '户均抄表耗时',
    style: {
      textAlign: 'center'
    },
    width: 130,
    type: 'custom',
    customRender (data, full) {
      const time = Number(moment(new Date()).format('x'))
      return data ? moment(time + data).to(time, true) : '-'
    }
  },
  waterUseNumChange: {
    label: '用量增减',
    width: 100,
    style: {
      textAlign: 'center'
    }
  },
  waveRangeRuleNum: {
    label: '波动范围',
    style: {
      textAlign: 'center'
    },
    width: 100,
    type: 'custom',
    customRender: (data, full) => {
      return full.waveRangeRuleNumStart + ' ~ ' + full.waveRangeRuleNumEnd
    }
  },
  waveRate: {
    label: '波动率',
    width: 90,
    type: 'custom',
    customRender: (data) => {
      return data ? (data + '%') : 0
    },
    style: {
      textAlign: 'center'
    }
  },
  waveRangeTypeId: {
    label: '波动原因',
    width: 120
  },
  // 事件记录
  desc: {
    label: '事件描述',
    width: 200,
    filter: {
      type: 'input',
      like: true
    }
  },
  eventTypeId: {
    width: 100,
    label: '类别',
    type: 'select',
    relation: 'eventType',
    filter: {
      type: 'select',
      live: true
    },
    style: {
      textAlign: 'center'
    }
  },
  eventSceneId: {
    width: 100,
    label: '场景',
    style: {
      textAlign: 'center'
    },
    type: 'select',
    relation: 'eventScene'
  },
  // 数据回填
  downloadTime: {
    label: '任务下载时间',
    width: 180,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD HH:mm:ss'
  },
  readingStartTime: {
    label: '上传开始时间',
    width: 180,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD HH:mm:ss'
  },
  readingEndTime: {
    label: '上传结束时间',
    width: 180,
    style: {
      textAlign: 'center'
    },
    type: 'time',
    dateType: 'YYYY-MM-DD HH:mm:ss'
  }
}



// WEBPACK FOOTER //
// ./src/containers/meterReading/fullColumns.js